import React, { useState } from 'react';
import { Tabs, Card, Form, Input, Button, message, Switch } from 'antd';
import { FacebookOutlined, GoogleOutlined, DatabaseOutlined } from '@ant-design/icons';
import './IntegrationsControl.css';

const { TabPane } = Tabs;

function IntegrationsControl() {
  const [activeTab, setActiveTab] = useState('facebook');
  const [facebookForm] = Form.useForm();
  const [googleAdsForm] = Form.useForm();
  const [geotabForm] = Form.useForm();

  const handleFacebookSubmit = async (values) => {
    try {
      // TODO: Implement API call to save Facebook settings
      console.log('Facebook Settings:', values);
      message.success('Facebook API settings saved successfully');
    } catch (error) {
      message.error('Failed to save Facebook settings');
    }
  };

  const handleGoogleAdsSubmit = async (values) => {
    try {
      // TODO: Implement API call to save Google Ads settings
      console.log('Google Ads Settings:', values);
      message.success('Google Ads API settings saved successfully');
    } catch (error) {
      message.error('Failed to save Google Ads settings');
    }
  };

  const handleGeotabSubmit = async (values) => {
    try {
      // TODO: Implement API call to save Geotab settings
      console.log('Geotab Settings:', values);
      message.success('Geotab integration settings saved successfully');
    } catch (error) {
      message.error('Failed to save Geotab settings');
    }
  };

  return (
    <div className="integrations-control-container">
      <div className="page-header">
        <h1>Integrations Control</h1>
        <p>Manage third-party API integrations and settings</p>
      </div>

      <Tabs activeKey={activeTab} onChange={setActiveTab} className="integrations-tabs">
        <TabPane
          tab={
            <span>
              <FacebookOutlined />
              Facebook API Settings
            </span>
          }
          key="facebook"
        >
          <Card title="Facebook Marketing API Configuration">
            <Form
              form={facebookForm}
              layout="vertical"
              onFinish={handleFacebookSubmit}
              initialValues={{
                enabled: true,
                app_id: '',
                app_secret: '',
                access_token: '',
                api_version: 'v18.0',
              }}
            >
              <Form.Item
                name="enabled"
                label="Enable Facebook Integration"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="app_id"
                label="Facebook App ID"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter your Facebook App ID" />
              </Form.Item>

              <Form.Item
                name="app_secret"
                label="Facebook App Secret"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Enter your Facebook App Secret" />
              </Form.Item>

              <Form.Item
                name="access_token"
                label="Access Token"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={3} placeholder="Enter your Facebook Access Token" />
              </Form.Item>

              <Form.Item
                name="api_version"
                label="API Version"
              >
                <Input placeholder="v18.0" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save Facebook Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>

        <TabPane
          tab={
            <span>
              <GoogleOutlined />
              Google Ads API Settings
            </span>
          }
          key="google-ads"
        >
          <Card title="Google Ads API Configuration">
            <Form
              form={googleAdsForm}
              layout="vertical"
              onFinish={handleGoogleAdsSubmit}
              initialValues={{
                enabled: true,
                developer_token: '',
                client_id: '',
                client_secret: '',
                refresh_token: '',
                customer_id: '',
              }}
            >
              <Form.Item
                name="enabled"
                label="Enable Google Ads Integration"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="developer_token"
                label="Developer Token"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Enter your Google Ads Developer Token" />
              </Form.Item>

              <Form.Item
                name="client_id"
                label="OAuth2 Client ID"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter your OAuth2 Client ID" />
              </Form.Item>

              <Form.Item
                name="client_secret"
                label="OAuth2 Client Secret"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Enter your OAuth2 Client Secret" />
              </Form.Item>

              <Form.Item
                name="refresh_token"
                label="Refresh Token"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={2} placeholder="Enter your Refresh Token" />
              </Form.Item>

              <Form.Item
                name="customer_id"
                label="Customer ID"
              >
                <Input placeholder="Enter your Google Ads Customer ID" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save Google Ads Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>

        <TabPane
          tab={
            <span>
              <DatabaseOutlined />
              Geotab Integration
            </span>
          }
          key="geotab"
        >
          <Card title="Geotab Integration Configuration">
            <Form
              form={geotabForm}
              layout="vertical"
              onFinish={handleGeotabSubmit}
              initialValues={{
                enabled: true,
                default_base_url: 'https://my.geotab.com',
                api_timeout: 30000,
                max_retries: 3,
              }}
            >
              <Form.Item
                name="enabled"
                label="Enable Geotab Integration"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                name="default_base_url"
                label="Default Base URL"
                rules={[{ required: true }]}
              >
                <Input placeholder="https://my.geotab.com" />
              </Form.Item>

              <Form.Item
                name="api_timeout"
                label="API Timeout (ms)"
              >
                <Input type="number" placeholder="30000" />
              </Form.Item>

              <Form.Item
                name="max_retries"
                label="Max Retries"
              >
                <Input type="number" placeholder="3" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save Geotab Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default IntegrationsControl;
